import { memo } from 'react';
import FJTextToImageRatio from '../view/FJTextToImageRatio';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSliceRatio } from '../../../../redux/slices/FJSliceTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import { useMemo } from 'react';

const FJTextToImageRatioContainer = memo(function FJTextToImageRatioContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curRatio = useSelector(state => state.textToImage.curRatio);
    const curModel = useSelector(state => state.textToImage.curModel);

    const changeRatio = useCallback(
        ratio => {
            dispatch(setSliceRatio(ratio.name));
        },
        [dispatch],
    );
    const curModelObj = useMemo(() => {
        return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
    }, [curModel]);

    return <FJTextToImageRatio curRatio={curRatio} changeRatio={changeRatio} curModelObj={curModelObj} />;
});

export default FJTextToImageRatioContainer;
